import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const YoutubeAnalyzer = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsYoutubeAnalyzer" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls className="d-block w-100">
                                    <source src="../IMG/YoutubeAnalyzer/SentimentSense.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="YoutubeAnalyzer" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">SentimentSense</p>
                            <p className="Project--info--subheading">YouTube Sentiment & Toxicity Analyzer</p>
                            <p className="Project--info--subheading">ML/AI Development</p>

                            <p className="Project--info--Para">
                                SentimentSense is an AI-powered tool that analyzes YouTube video comments, classifying them as positive, negative, or neutral.
                                It offers clear sentiment distribution through bar and pie charts and evaluates individual comment toxicity using deep learning.
                            </p>

                            <p className="Project--info--Para">
                                The system enables both broad audience insight and detailed analysis of comment tone—supporting use cases in feedback monitoring,
                                content moderation, and public sentiment research.
                            </p>
                        </div>

                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/SentimentSense---YouTube-Sentiment-Analyzer" target='__blank'>GitHub Repository</a>
                        </div>

                        <div className="Project--info--tech">
                            <p>Python</p>
                            <p>FastAPI</p>
                            <p>YouTube Data API</p>
                            <p>TensorFlow</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default YoutubeAnalyzer